export default {
  'wallet.headerTitle': 'Wallet List',
  'wallet.newWallet': 'New Wallet',
  'wallet.oldWallet': 'Old Wallet',
  'wallet.referralCode': 'Referral Code',
  'wallet.level': 'Level',
  'wallet.socialMapping': 'Social Mapping',
  'wallet.coweBalance': 'COWe Balance',
  'wallet.survey': 'Survey',
  'wallet.action': 'Actions',
  'wallet.copySuccess': 'Copied to clipboard!',
  'wallet.level.all': 'All',
  'wallet.level.0': 'Level 0',
  'wallet.level.1': 'Level 1',
  'wallet.level.2': 'Level 2',
  'wallet.social.xLinked': 'X Linked',
  'wallet.social.xNotLinked': 'X Not Linked',
  'wallet.social.tgVerified': 'Telegram (Verified)',
  'wallet.social.tgUnverified': 'Telegram (Unverified)',
  'wallet.social.tgNotLinked': 'Telegram Not Linked',
  'wallet.social.gmailLinked': 'Gmail Linked',
  'wallet.social.gmailNotLinked': 'Gmail Not Linked',
  'wallet.survey.all': 'All',
  'wallet.survey.done': 'Completed',
  'wallet.survey.notDone': 'Not Completed',
  'wallet.survey.placeholder': 'Please select',
  'wallet.detailTelegram': 'Social Media Detail',
  'wallet.social.tab.x': 'X (Twitter)',
  'wallet.social.tab.telegram': 'Telegram',
  'wallet.social.tab.gmail': 'Gmail',
  'wallet.social.fullName': 'Full Name',
  'wallet.social.providerUserId': 'Provider User ID',
  'wallet.social.status': 'Status',
  'wallet.social.createdAt': 'Created At',
  'wallet.social.metadata': 'Metadata',
  'wallet.social.email': 'Email',
  'wallet.social.phone': 'Phone Number',
  'wallet.social.verifiedAt': 'Verified At',
  'wallet.social.verified': 'Verified',
  'wallet.social.unverified': 'Unverified',
  'wallet.social.notLinked': 'Not Linked',
  'wallet.detailUser': 'User Detail',
};
